import { CircularProgress, Typography } from "@mui/material";
import { ILoaderProps } from "./types";

export const Loader = ({
  loading = true,
  type = "inline",
  size = 40,
  tip,
  children,
  className = "",
}: ILoaderProps) => {
  const spinner = (
    <div className="flex flex-col items-center gap-2">
      <CircularProgress
        size={size}
        sx={{
          color: "var(--color-primary)",
        }}
      />
      {tip && <Typography fontSize={14}>{tip}</Typography>}
    </div>
  );

  if (type === "fullscreen") {
    if (!loading) return null;

    return (
      <div
        className={`fixed inset-0 z-9999 flex items-center justify-center backdrop-blur-sm bg-white/80 dark:bg-[rgba(11,12,13,0.7)] ${className}`}
      >
        {spinner}
      </div>
    );
  }

  if (type === "content") {
    if (!loading) return <>{children}</>;

    if (!children) {
      return (
        <div
          className={`absolute inset-0 z-10 flex items-center justify-center backdrop-blur-sm rounded-2xl bg-white/60 dark:bg-[rgba(11,12,13,0.6)] ${className}`}
        >
          {spinner}
        </div>
      );
    }

    return (
      <div className={`relative w-full min-h-[calc(100vh-48px)] ${className}`}>
        <div className="w-full h-full">{children}</div>

        <div className="absolute inset-0 -m-6 flex items-center justify-center backdrop-blur-sm rounded-2xl bg-white/70 dark:bg-[rgba(11,12,13,0.65)] z-50">
          {spinner}
        </div>
      </div>
    );
  }

  if (type === "inline") {
    if (!loading) return <>{children}</>;

    return (
      <div className={`flex items-center justify-center py-6 ${className}`}>
        {spinner}
      </div>
    );
  }

  return null;
};
